/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputEwFrequencyRangeItem
 */
export interface InputEwFrequencyRangeItem {
    /**
     * 
     * @type {number}
     * @memberof InputEwFrequencyRangeItem
     */
    max?: number;
    /**
     * 
     * @type {number}
     * @memberof InputEwFrequencyRangeItem
     */
    min?: number;
    /**
     * "MHz" або "GHz"
     * @type {string}
     * @memberof InputEwFrequencyRangeItem
     */
    unit?: string;
}

/**
 * Check if a given object implements the InputEwFrequencyRangeItem interface.
 */
export function instanceOfInputEwFrequencyRangeItem(value: object): boolean {
    return true;
}

export function InputEwFrequencyRangeItemFromJSON(json: any): InputEwFrequencyRangeItem {
    return InputEwFrequencyRangeItemFromJSONTyped(json, false);
}

export function InputEwFrequencyRangeItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputEwFrequencyRangeItem {
    if (json == null) {
        return json;
    }
    return {
        
        'max': json['max'] == null ? undefined : json['max'],
        'min': json['min'] == null ? undefined : json['min'],
        'unit': json['unit'] == null ? undefined : json['unit'],
    };
}

export function InputEwFrequencyRangeItemToJSON(value?: InputEwFrequencyRangeItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'max': value['max'],
        'min': value['min'],
        'unit': value['unit'],
    };
}

